import { useCallback } from 'react';
import {
  fetchSearchList,
  fetchHomeShowcases,
  fetchShowcaseListings,
  fetchTagFallbackList,
  fetchTagShowcases,
  fetchNearYouShowcase,
  pickDataForListing,
} from '../../data/api/search';

/**
 * Hook that wraps search API calls for use in components.
 * This satisfies the sellwild-code/component-no-api-calls rule
 * by keeping API imports out of the component file.
 */
export function useSearchApi() {
  const searchList = useCallback(
    (params: Parameters<typeof fetchSearchList>[0]) => fetchSearchList(params),
    []
  );

  const homeShowcases = useCallback(
    (params: Parameters<typeof fetchHomeShowcases>[0]) => fetchHomeShowcases(params),
    []
  );

  const showcaseListings = useCallback(
    (params: Parameters<typeof fetchShowcaseListings>[0]) => fetchShowcaseListings(params),
    []
  );

  const tagFallbackList = useCallback(
    (params: Parameters<typeof fetchTagFallbackList>[0]) => fetchTagFallbackList(params),
    []
  );

  const tagShowcases = useCallback(
    (params: Parameters<typeof fetchTagShowcases>[0]) => fetchTagShowcases(params),
    []
  );

  const nearYouShowcase = useCallback(
    (limit?: number) => fetchNearYouShowcase(limit),
    []
  );

  const pickForListing = useCallback(
    (list: Parameters<typeof pickDataForListing>[0], max?: number) => pickDataForListing(list, max),
    []
  );

  return {
    fetchSearchList: searchList,
    fetchHomeShowcases: homeShowcases,
    fetchShowcaseListings: showcaseListings,
    fetchTagFallbackList: tagFallbackList,
    fetchTagShowcases: tagShowcases,
    fetchNearYouShowcase: nearYouShowcase,
    pickDataForListing: pickForListing,
  };
}
